import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {

    const { occurrenceCityFact } = useReportFiltersFetch({ fetchOccurrenceCityFact: true });

    const visibilityOptions = [
        { value: "ALL-OCC", label: "Todas" },
        { value: "PUBLIC-OCC", label: "Públicas" },
        { value: "PRIVATE-OCC", label: "Privadas" },
    ];

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className="space-y-4">
                    <InputForm
                        id="plate"
                        label="Placa *"
                        classNameWrapper="w-full"
                        autocomplete="off"
                        mask={MaskDefault.plateNoRestrict}
                        value={filters.plate}
                        onChange={({ target }) => setFilters(prev => ({ ...prev, plate: target.value?.toUpperCase() }))}
                    />
                    <SelectComponent
                        id="visibility"
                        label="Visibilidade"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={false}
                        options={visibilityOptions}
                        value={filters.visibility}
                        onChange={(value) => setFilters(prev => ({ ...prev, visibility: value }))}
                    />
                    <SelectComponent
                        id="city-fact"
                        label="Município do fato"
                        classNameWrapper="w-full"
                        wrapValues={true}
                        isClearable={true}
                        isMulti={true}
                        options={occurrenceCityFact}
                        value={filters.cityFact}
                        onChange={(value) => setFilters(prev => ({ ...prev, cityFact: value }))}
                    />
                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className="pl-1"
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({ ...prev, archivedOccurrences: e.target.checked }))}
                    />
                    <InputCheckbox
                        id="onlyMyCity"
                        label="Apenas ocorrências da minha corporação"
                        className="pl-1"
                        checked={filters.onlyMyCity}
                        onChange={(e) => setFilters(prev => ({ ...prev, onlyMyCity: e.target.checked}))}
                    />
                </form>
            </div>
        </>
    )
}